/**
 * @description Configuração do store do Redux
 * @author Bene Lemuel Dantas Gondim
 * @file configureStore.js
 *
 * @license Copyright (c) 2020 SIGEP DIGETI ITEP/RN
 */

import { applyMiddleware, createStore, compose } from 'redux'
import rootReducer from 'reducers'
import { middleWareLogs } from '../logger'

export default function configureStore(preloadedState = {}) {
  const store = createStore(
    rootReducer,
    preloadedState,
    compose(applyMiddleware(...middleWareLogs))
  )
  return store
}
